// src/context/BaseUrlContext.js
import React, { createContext, useContext } from "react";

const BaseUrlContext = createContext();

export const BaseUrlProvider = ({ children }) => {
  const baseUrl = "https://riddhiedu.org/api/"; // ✅ Your base URL here http://localhost/Riddhi-collage/
  //https://riddhiedu.org/api/
  return (
    <BaseUrlContext.Provider value={{ baseUrl }}>
      {children}
    </BaseUrlContext.Provider>
  );
};

// Custom hook for using baseUrl
export const useBaseUrl = () => useContext(BaseUrlContext);
